import React,  { useContext, useEffect,useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, Box, Tabs, Tab, Button } from '@material-ui/core';
import { useStyles } from '../styles';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Store } from '../Store';
import MainFooter from '../components/MainFooter';
import { keyframes } from '@emotion/react';
import { styled } from '@mui/material/styles';
import Axios from 'axios';
import config,{ getParameterByName,merchantCode} from '../util';
import { addToOrder, clearOrder, removeFromOrder } from "../actions";

const MyOrders = () => {
  const { state, dispatch } = useContext(Store);
  const styles = useStyles();
  const history = useHistory();
  const [myorders, setMyOrders] = useState([]);
  const [tabSel, setTabSel] = React.useState(0);
  let { setting } = state.userSetting;
  if(!setting){
    setting = JSON.parse(localStorage.getItem("userInfo"));
  }
  const baseURL = config.baseURL
  const customersInfo = sessionStorage.getItem("customerInfo") ? JSON.parse(sessionStorage.getItem("customerInfo")) : null;
 useEffect(() => {
      if (!customersInfo || !customersInfo.customer) return;
      let cusId = customersInfo.customer.id || customersInfo.customer._id;

      let subPath = `/api/orders/customer/${cusId}?merchantCode=${merchantCode}`;
      Axios.get (`${baseURL}${subPath}`).then( res => {
        console.log(res);
        if (res.data && Array.isArray(res.data)) {
          setMyOrders(res.data); 
        }
      }).catch(err => console.error("Error fetching orders:", err));
      
 },[])
  const handleTabChange = (event, newValue) => {
    setTabSel(newValue);
  }

  const reorderItems = (oldOrder) => {
    let items = oldOrder.orderItems;
    items.map(itm => addToOrder(dispatch, itm));
  }

  const goto = (subpath) => {
    history.push('/'+subpath+'?' + window.location.href.split('?')[1]);
  }

  return (
    <Box
      className={styles.root}
      style={{ padding: "0px!important", backgroundColor: setting.themeColor }}
    >
      <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, pt: 2, pb: 1 }}>
        <ArrowBackIosNewIcon 
          style={{color: setting.themeTxtColor}} 
          onClick={() => history.goBack()}
        />
        <Typography variant="h6" style={{ color: setting.themeTxtColor, fontFamily: setting.themePrimaryFontFam }}>
          My Previous Orders
        </Typography>
        <Box style={{width: "24px"}} /> {/* Spacer for alignment */}
      </Box>

      <Box style={{ 
        padding: "20px", 
        minHeight: "calc(100vh - 180px)",
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start'
      }}>
       {myorders.map((mo, index) => {
        let ord = mo;
        if (!ord || !ord.orderItems || ord.orderItems.length === 0) return null;
        return <div key={index} style={{padding:"10px", margin:"10px", background:setting.themeTxtColor, borderRadius:"8px",width:"100%",}}>
              <div style={{display:"flex",justifyContent:"space-between",flexDirection:"row"}}><h3 style={{fontColor:setting.themeColor}}>{ord.orderItems[0].name} <span style={{fontSize:"0.8em"}}>{ord.orderItems.length>1 && (`+ ${ord.orderItems.length -1} Items`)}</span>  </h3>
                <h4 style={{float:"right",display:"inline",color:ord.orderStatus.toUpperCase()=="DELIVERED"?"green":"orange"}}>{ord.orderStatus.toUpperCase()}</h4></div>
              <span style={{fontColor:"#fff",marginBottom:"10px"}}>{'Order date: '+ new Date(mo.updatedAt).toLocaleString()}</span>
               <Button
                onClick={()=> reorderItems(mo)}
                variant="contained"
                size="large"
                style={{
                  backgroundColor: setting.themeTxtColor, 
                  color: setting.themeColor,
                  fontWeight:'500',
                  borderRadius:"8px",
                  padding: '5px 8px',
                  maxWidth:"150px",
                  margin:"20px",
                  fontSize:"0.9em",
                  border:"1px solid "+setting.themeColor,
                  float:"right"
                }}
              >
                REORDER
              </Button>

        </div>

       })}
      </Box>

      <MainFooter tabSel={2} />
    </Box>
  );
};

export default MyOrders;
